<section>
  @if (form) {
    <header class="mb-24">
      <div class="flex items-center justify-end space-x-2">
        <p-button
          icon="pi pi-play-circle"
          label="Preview"
          (onClick)="onPreviewClick()" />
        <p-button
          outlined
          icon="pi pi-sync"
          label="Restart"
          [loading]="isLoading"
          (onClick)="onRestartClick($event)" />
        @if (hasChanges) {
          <p-button
            icon="pi pi-save"
            label="Save"
            [loading]="isLoading"
            [disabled]="form.invalid"
            appThrottleClick
            [throttleTime]="500"
            (throttleClick)="onSaveClick()" />
          <p-button
            icon="pi pi-undo"
            label="Reset"
            severity="warn"
            (onClick)="onResetClick($event)"></p-button>
        }
      </div>
    </header>
    @if (form.controls.scenes.controls.length) {
      @for (
        scene of form.controls.scenes.controls;
        track scene.controls.$key.value
      ) {
        <app-video-scene
          [session]="session"
          [idea]="idea"
          [scene]="scene"
          (sceneDelete)="onSceneDeleteClick(scene)" />
      }
    } @else {
      <div class="flex items-center justify-center">
        <p-button
          rounded
          outlined
          icon="pi pi-plus"
          severity="info"
          label="Add a Video Scene"
          (onClick)="onSceneAddClick()" />
      </div>
    }
  } @else {
    <header>
      <div class="flex items-center justify-end space-x-2">
        <p-button
          icon="pi pi-plus"
          label="Create"
          [loading]="isLoading"
          appThrottleClick
          [throttleTime]="500"
          (throttleClick)="onCreateClick()" />
      </div>
    </header>
  }
</section>
